/*
 * @Author: xinghanhu@clubfactory.com
 * PreviewDialog： 预览弹窗
 * @Date: 2019-05-30 13:34:08
 * @Last Modified by: xinghanhu@clubfactory.com
 * @Last Modified time: 2019-12-10 16:37:33
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Gesture from 'rc-gesture';
import classnames from 'classnames';
import Icon from '../icon';
class PreviewDialog extends React.Component {
    constructor(props) {
        super(props);
        this.ySlideLen = 260;
        this.yOpacityLen = 160;
        this.xSlideLen = 100;
        this.onPan = (() => {
            let lastOffset = 0;
            let slideDirection = '';
            let finalOffset = 0;
            const getLastOffset = () => {
                let offset = +`${lastOffset}`.replace('%', '');
                if (`${lastOffset}`.indexOf('%') >= 0) {
                    offset /= 100;
                    offset *= this.layout.clientWidth;
                }
                return offset;
            };
            return {
                onPanStart: (status) => {
                    this.setState({
                        startPoint: status.startTouches[0],
                        isMoving: true,
                    });
                },
                onPanMove: (status) => {
                    if (!status.moveStatus || !this.layout)
                        return;
                    if (Math.abs(status.moveStatus.y) > Math.abs(status.moveStatus.x) || slideDirection === 'vertical') {
                        // 垂直方向关闭
                        const offset = status.moveStatus.y;
                        if (!slideDirection)
                            slideDirection = 'vertical';
                        const item = this.itemList[this.state.itemIndex];
                        const scale = (this.ySlideLen - Math.abs(offset)) > 0 ? (this.ySlideLen - Math.abs(offset)) : 0;
                        item.style.transform = `translate3d(0px, ${offset}px, 1px) scale(${scale / this.ySlideLen})`;
                        finalOffset = Math.abs(offset);
                        const opcityScale = (this.yOpacityLen - Math.abs(offset)) > 0 ? (this.yOpacityLen - Math.abs(offset)) : 0;
                        this.setState({
                            showPrev: false,
                            showNext: false,
                            slidOpacity: opcityScale / this.yOpacityLen,
                        });
                    }
                    else {
                        // 水平方向切换
                        if (!slideDirection)
                            slideDirection = 'horizontal';
                        const offset = getLastOffset() + (status.moveStatus.x);
                        const moveOffset = status.moveStatus.x;
                        this.layout.style.transform = `translate3d(${offset}px, 0px, 1px)`;
                        finalOffset = Math.abs(moveOffset);
                        this.setState({
                            showPrev: moveOffset > 0,
                            showNext: -moveOffset > 0,
                        });
                    }
                },
                onPanEnd: () => {
                    this.layout.style.transform = `translate3d(0px, 0px, 1px)`;
                    this.setState({
                        isMoving: false,
                    });
                    if (slideDirection === 'vertical') {
                        this.verticalSlideEnd(finalOffset);
                    }
                    this.horizontalSlideEnd();
                    slideDirection = '';
                },
                setCurrentOffset: (offset) => lastOffset = offset,
            };
        })();
        this.handleClose = () => {
            this.setState({
                slidOpacity: 0,
            });
            const item = this.itemList[this.state.itemIndex];
            item.style.opacity = 0;
            item.style.transform = `translate3d(0px, 0px, 1px) scale(1)`;
            this.props.close(this.state.itemIndex);
        };
        this.initPreviewNode = () => {
            this.layout.style.transform = `translate3d(-${this.state.itemIndex * 100}%, 0px, 1px)`;
            this.itemList.forEach((item) => {
                item.style.transform = 'translate3d(0px, 0px, 1px) scale(1)';
                item.style.opacity = '1';
            });
        };
        this.horizontalSlideEnd = () => {
            const { showNext, showPrev } = this.state;
            const { items } = this.props;
            const { setCurrentOffset } = this.onPan;
            let index = this.state.itemIndex;
            if (showNext) {
                index = index + 2 > items.length ? index : index + 1;
            }
            else if (showPrev) {
                index = index < 1 ? index : index - 1;
            }
            this.setState({
                itemIndex: index,
            });
            setCurrentOffset(`-${index * 100}%`);
            this.layout.style.transform = `translate3d(-${index * 100}%, 0px, 1px)`;
            setTimeout(() => {
                this.props.swipeCallBack(index);
            }, 300);
        };
        this.verticalSlideEnd = (finalOffset) => {
            if (finalOffset > this.ySlideLen / 2) {
                this.handleClose();
            }
            else {
                const item = this.itemList[this.state.itemIndex];
                item.style.transform = `translate3d(0px, 0px, 1px) scale(1)`;
                this.setState({
                    slidOpacity: 1,
                });
            }
        };
        this.setContentLayout = (div) => {
            this.layout = div;
        };
        this.state = {
            itemIndex: props.itemIndex || 0,
            startPoint: null,
            showPrev: false,
            showNext: false,
            direction: null,
            slidOpacity: 1,
            isMoving: false,
        };
    }
    componentDidMount() {
        this.initPreviewNode();
    }
    componentWillUnmount() {
        this.handleClose();
    }
    // 展开时防止body滚动
    // bodyDisaleScroll = (e: any) => {
    //   e.preventDefault()
    //   e.stopPropagation()
    // }
    render() {
        const { items, className, bottomOperateContent, showCloseIcon } = this.props;
        const { itemIndex, slidOpacity, isMoving } = this.state;
        const _a = this.onPan, { setCurrentOffset } = _a, onPan = __rest(_a, ["setCurrentOffset"]);
        const dialogCls = classnames('cfm_preview-dialog', className);
        const containerCls = classnames('cfm_preview__container', {
            'cfm_preview__container__transtion': !isMoving,
        });
        setCurrentOffset(`-${itemIndex * 100}%`);
        return (<div className={dialogCls} tabIndex={-1} role="dialog">
        <div className="cfm_preview__bg" style={{ opacity: slidOpacity }}/>
        <div className="cfm_preview__scroll-wrap">
          <Gesture {...onPan} direction={'all'}>
            <div ref={this.setContentLayout} className={containerCls}>
              {items.map((item, i) => {
            return <div key={i + ''} ref={(node) => {
                this.itemList = this.itemList || [];
                this.itemList[i] = node;
            }} className="cfm_preview__item">
                    <div className="cfm_preview__zoom-wrap">
                      <img onClick={this.handleClose} className="cfm_preview__img" src={item.src}/>
                    </div>
                  </div>;
        })}
            </div>
          </Gesture>
          <div className="cfm_preview__ui" style={{ opacity: slidOpacity }}>
            <div className="cfm_preview__top-bar">
              <div className="cfm_preview__top-bar__center">
                <span>{`${itemIndex + 1} / ${items.length}`}</span>
                {showCloseIcon && <Icon onClick={this.handleClose} type='close'/>}
              </div>
            </div>
            <div className="cfm_preview__bottom">
              {items[itemIndex].title ? <div className="cfm_preview__caption">{items[itemIndex].title}</div> : null}
              {bottomOperateContent ? <div className="cfm_preview__bottom-bar">{bottomOperateContent(items[itemIndex])}</div> : null}
            </div>
          </div>
        </div>
      </div>);
    }
}
PreviewDialog.defaultProps = {
    items: [],
    options: {},
    close: () => { },
    swipeCallBack: () => { },
    showCloseIcon: true,
};
export default PreviewDialog;



// WEBPACK FOOTER //
// ./components/photo-preview/PreviewDialog.tsx